<template>
  <div class="fileManagement">
    <div class="filetop">
      <div
        @click="detailClick(item, index)"
        class="fileList"
        v-for="(item, index) in countList"
        :key="index"
      >
        <div class="filetitle">{{ item.name }}</div>
        <div class="fileblue">{{ item.value }}</div>
      </div>
    </div>
    <div class="filecenter">
      <div class="filecentertitle">档案管理</div>
      <div class="filebottom">档案总数约 {{ countAll }}</div>
    </div>
    <div class="filesearch">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item>
          <el-select
            v-model="tableParams.type"
            placeholder=""
            :style="{ width: '130px' }"
            size="large"
            clearable
          >
            <el-option
              v-for="(item, index) in fileList"
              :key="index"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="tableParams.search"
            placeholder=""
            :style="{ width: '400px' }"
            size="large"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <h-button
            @click="searchbtn"
            type="primary"
            size="large"
            :style="{ width: '120px', height: '48px' }"
            >搜索</h-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- v-model="formVisible" -->
    <filesearchList
      v-model:searchVisible="searchVisible"
      :tableParams="tableParams"
    ></filesearchList>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import _ from "lodash";
// import fileManagementDialog from './fileManagement/fileManagementDialog';
import filesearchList from "./fileManagement/filesearchList";

import { archiveslist } from "@/api/threeSolid/fileManagement";
export default defineComponent({
  name: "fileManagement",
  components: { filesearchList },
  props: {},
  setup(props) {
    const data = reactive({
      fileList: [
        { name: "人员档案", value: "1" },
        { name: "车辆档案", value: "2" },
        { name: "单位档案", value: "3" },
        { name: "房屋档案", value: "4" },
        // { name: "社区档案", value: "5" },
      ],
      tableParams: {
        search: "",
        type: "",
      },
      searchVisible: false,
      countList: [],
      countAll: "",
      formRef: {},
    });
    const refData = toRefs(data);
    const searchbtn = () => {
      data.searchVisible = true;
      data.tableParams = _.cloneDeep(data.tableParams);
    };
    const detailClick = (item, index) => {
      data.tableParams.type = String(item.id + 1);
      data.searchVisible = true;
      data.tableParams = _.cloneDeep(data.tableParams);
    };
    const archiveslistall = async () => {
      const res = await archiveslist();
      data.countList = res.data.filter((element) => {
        if (element.name != "社区档案") return element;
      });
      console.log(data.countList);
      data.countAll = data.countList.reduce(function (prev, cur) {
        // return prev + cur;
        return prev + parseInt(cur.value);
      }, 0);
    };
    archiveslistall();
    return {
      ...refData,
      detailClick,
      searchbtn,
    };
  },
});
</script>
<style lang="scss" scoped>
.fileManagement {
  width: 100%;
  height: 100%;
  background-image: url("~@/assets/images/threeSolid/threebg.png");
  background-size: 100% 100%;
  position: relative;
  color: #fff;
  .filetop {
    display: flex;
    justify-content: center;
    .fileList {
      cursor: pointer;
      width: 185px;
      height: 100px;
      background-image: url("~@/assets/images/home/house.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      margin: 20px 10px;
      // font-weight: bold;
      .fileblue {
        color: #1bfffe;
      }
      .filetitle {
        font-family: "YouSheBiaoTiHei";
        font-size: 32px;
      }
      .fileblue {
        font-family: "YouSheBiaoTiHei";
        font-size: 26px;
      }
    }
  }
  .filecenter {
    width: 100%;
    text-align: center;
    margin-top: 14vh;
    .filecentertitle {
      font-size: 50px;
      // position: fixed;
      left: 860px;
      top: 290px;
    }
    .filebottom {
      font-size: 24px;
      line-height: 40px;
    }
  }
  .filesearch {
    display: flex;
    justify-content: center;
    margin-top: 8vh;
    :deep(.el-input__inner) {
      height: 48px;
      &::placeholder {
        color: #fff;
      }

      &::-webkit-input-placeholder {
        /* WebKit browsers 适配谷歌 */
        color: #fff;
      }

      &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 适配火狐 */
        color: #fff;
      }

      &::-moz-placeholder {
        /* Mozilla Firefox 19+ 适配火狐 */
        color: #fff;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10+  适配ie*/
        color: #fff;
      }
    }
    :deep(input) {
      background-color: #1e406e !important;
      border: 1px solid #1e406e;
      color: #fff;
    }
  }
}
</style>
